import {Component} from '@angular/core';
import {Location} from '@angular/common';

@Component({
  selector: 'si-go-back-button',
  templateUrl: './go-back-button.component.html',
  styleUrls: ['./go-back-button.component.scss']
})
export class GoBackButtonComponent {

  constructor(
    private location: Location
  ) { }

  onClickReturn(): void {
    this.location.back();
  }
}
